// Pinia Store
import { defineStore } from 'pinia';
import { useNuxtApp } from 'nuxt/app';
import { ref, type Ref } from 'vue';
import { AW_AX_CACHE_GLOBAL } from '~~/common/plugins/axios/awAxCache';
import { setErrorNotification } from '~~/common/utils/helper';
import type { Schema } from '~~/common/types/api';

export const useNotificationBarStore = defineStore('notificationBar', () => {
  const nuxtApp = useNuxtApp();

  const notifications: Ref<Schema<'NotificationListModel'>[] | null> = ref(null);

  async function fetchNotifications () {
    const {
      $api,
      $logger,
    } = nuxtApp;
    try {
      notifications.value = await $api.$get<Schema<'NotificationListModel'>[]>('/notification_list', { awAxCache: AW_AX_CACHE_GLOBAL });
    } catch (error) {
      $logger.error(error);
      setErrorNotification({ nuxtApp, error });
    }
  }

  return {
    notifications,
    fetchNotifications,
  };
});
